
import { useState } from 'react';
import { WizardFormData, WizardState, WizardActions } from './types';

export const useWizardState = (): [WizardState, WizardActions] => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState<WizardFormData>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Initialize with all steps invalid except summary
  const [stepValidity, setStepValidity] = useState<Record<number, boolean>>({
    0: false, // Provider Details
    1: false, // User Assignment
    2: false, // Lead Account
    3: false, // Strategy Setup
    4: false, // Account Setup
    5: true,  // Summary step is always valid
  });

  return [
    { currentStep, formData, stepValidity, isSubmitting },
    { 
      setCurrentStep, 
      setFormData, 
      setStepValidity, 
      setIsSubmitting 
    }
  ];
};
